import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";


const Definition: QuestionnaireDefinition = {
  name: 'Leicester Cough Questionnaire (LCQ)',
  key: 'leicesterCoughQuestionnaire',
  title: 'Leicester Cough Questionnaire (LCQ)',
  description: '',
  cohort: 'respiratory',
  type: 'questionnaire',
  estimatedCompletionTime: '2:20',
  groups: [
    {
      key: 'leicesterCough',
      content: <Typography>Please answer the following questions</Typography>,
      questions: [
        {
          key: 'chestStomachPains',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you had chest or stomach pains as a result of your cough?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'sputumPhlegm',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you been bothered by sputum (phlegm) production when you cough?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'tired',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you been tired because of your cough?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'embarrassed',
          type: 'multiple-choice',
          question: 'How often during the last 2 weeks have you felt embarrassed by your coughing?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'anxious',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, my cough has made me feel anxious.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'interfereJob',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, my cough has interfered with my job or other daily tasks.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'interfereLife',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, I felt that my cough interfered with the overall enjoyment of my life.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'exposurePaint',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, exposure to paint or fumes has made me cough.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'sleep',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, has your cough disturbed your sleep?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'bout',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, how many times a day have you had a coughing bout?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'frustrated',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, my cough has made me feel frustrated.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'fedUp',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, my cough has made me feel fed up.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'hoarseVoice',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you suffered from a hoarse voice as a result of your cough?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'seriousIllness',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you worried that your cough may indicate serious illness?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'otherPeople',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you been concerned that other people think something is wrong with you, because of your cough?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'interruptConversation',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, my cough has interrupted conversation or telephone calls.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'partner',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, I feel that my cough has annoyed my partner, family, or friends.',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'feltInControl',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you felt in control of your cough?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          key: 'energy',
          type: 'multiple-choice',
          question: 'In the last 2 weeks, have you had a lot of energy?',
          options: [
            { key: 'noneOfTheTime', displayName: 'None of the time' },
            { key: 'hardlyAnyOfTheTime', displayName: 'Hardly any of the time' },
            { key: 'aLittleOfTheTime', displayName: 'A little of the time' },
            { key: 'someOfTheTime', displayName: 'Some of the time' },
            { key: 'aGoodBitOfTheTime', displayName: 'A good bit of the time' },
            { key: 'mostOfTheTime', displayName: 'Most of the time' },
            { key: 'allOfTheTime', displayName: 'All of the time' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
      ]
    }
  ]
};
export const LeicesterCoughDefinition = Definition;

export const LeicesterCough = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'leicesterCoughQuestionnaires',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  console.log('LeicesterCough component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('LeicesterCough completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    setQuestionnaire(questionnaire);
  }

  console.log('LeicesterCough component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
    </div>
  );
}
